import React from 'react'

const ChevronDown = ({ width = 12, height = 9, fill = '#6B6B6B' }) => (
  <svg
    fill={fill}
    height={height}
    viewBox={'0 0 12 9'}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.0013 1.49681C11.9988 1.15362 11.8671 0.829079 11.6413 0.60944C11.4385 0.409519 11.1759 0.311951 10.9114 0.338232C10.6469 0.364513 10.4022 0.512487 10.2313 0.749552L6.00128 6.68094L1.77128 0.749552C1.41781 0.253021 0.786535 0.185063 0.361275 0.597764C-0.0639843 1.01047 -0.122187 1.74754 0.231275 2.24408L5.23128 9.24965C5.42126 9.51735 5.70352 9.67227 6.00128 9.67227C6.29903 9.67227 6.5813 9.51735 6.77128 9.24965L11.7713 2.24408C11.9204 2.03401 12.0017 1.76962 12.0013 1.49681Z" />
  </svg>
)

export default ChevronDown
